import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import FichaTecnica from "../FichaTecnica/FichaTecnica";

function IndexJunta() {
  const cookies = new Cookies();
  const [list, setList] = useState([]);

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/ObtenerQSolicitudesPorEvaluador?EvaluadorId=0",
    })
      .then((Response) => {
        var respuesta = Response.data[0];
        cookies.set("institucionid", respuesta.institucionId, { path: "/" });
        setList(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);

  return (
    <Fragment>
      <div className="text-center">
        <div className="container-fluid">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Index Junta Directiva
              </h6>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table
                  className="table table-bordered"
                  id="dataTable"
                  width="100%"
                  cellspacing="0"
                >
                  <thead>
                    <tr>
                      <th>Id Solicitud</th>
                      <th>Nombre Institución</th>
                      <th>Estado</th>
                      <th>ID Institución</th>
                      <th>Tipo de Solicitud</th>
                      <th>Ficha</th>
                      <th>Informe</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.map((item) => (
                      <tr key={item.solicitud}>
                        <td>{item.solicitud}</td>
                        <td>{item.nombreInstitucion}</td>
                        <td>{item.estado}</td>
                        <td>{item.institucionId}</td>
                        <td>{item.tipoSolicitud}</td>
                        <td>
                          <FichaTecnica
                            idSolicitud={item.solicitud}
                            institucion={item.institucionId}
                            tipoSolicitud={item.tipoSolicitud}
                            ano={item.ano}
                          />
                        </td>
                        <td>
                          <Link
                            to={`/InformeEvaluador/${item.institucionId}/${item.solicitud}`}
                          >
                            Informe
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default IndexJunta;
